module.exports = __webpack_public_path__ + "static/media/g5.fd16aa09.jpg";